<template>
  <v-container>
    <Dialog @close="cerrar" @edit="editar" :dialog="dialog" :task="obj" />
    <Modal
      @save="guardar"
      @delete="eliminar"
      @close="cerrar"
      :object="obj"
      :update="update"
      :show="show"
    />
    <template>
      <v-row>
        <v-col cols="12" md="4">
          <span class="align-center">
            Tareas
          </span>
        </v-col>
        <v-col cols="12" md="4">
          <!-- <v-autocomplete
            v-model="value"
            :tasks="tasksFiltro"
            outlined
            dense
            label="Filtrar por..."
            @change="selectFiltro()"
          ></v-autocomplete> -->
        </v-col>
        <v-col cols="12" md="4">
          <v-btn color="primary" dark class="mb-2" @click="abrirModal"
            >Nueva</v-btn
          >
        </v-col>
      </v-row>
    </template>
    <v-row dense>
      <v-col v-for="(item, i) in tareas" :key="i" cols="6">
        <v-card :color="item.color" dark>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title
                class="headline"
                v-text="item.nombre"
              ></v-card-title>
              <v-card-subtitle>
                {{ "Creada por: " }} {{nameUsrFn(item.creado_por)}}
              </v-card-subtitle>

              <v-card-action>
                <v-btn
                  class="ml-2 mt-5"
                  outlined
                  rounded
                  small
                  @click="verAct(item)"
                >
                  VER
                </v-btn>
              </v-card-action>
            </div>

            <v-avatar class="ma-3" size="125" tile>
              <v-icon v-if="item.estado" x-large>check_box</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Dialog from "../components/base/Dialog2";
import Modal from "../components/base/modal/ModalTarea";
import moment from "moment";

export default {
  data: () => ({
    nameUsr: "",
    dialog: false,
    show: false,
    update: false,
    obj: {
      creado_por: null,
      ultimo_editar: null,
      nombre: null,
      create_at: moment(new Date()).format("LL"),
      finish_at: moment(new Date()).format("LL"),
      prioridad: null,
      comentarios: null,
      estado: null,
    },
  }),
  async created() {
    moment.locale("ES");
  },
  components: {
    Dialog,
    Modal,
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario", "usuarios"]),
    ...mapState("tareaNamespace", ["tareas", "tarea"]),
  },
  methods: {
    ...mapActions("tareaNamespace", [
      "getTareas",
      "getTarea",
      "saveTarea",
      "updateTarea",
      "deleteTarea",
    ]),
    nameUsrFn(id) {
      let usuarios = this.usuarios;
      let nombre = usuarios.find(e => e.id == id).nombre;
      return nombre;
    },
    verAct(item) {
      this.obj.id = item.id;
      this.obj.creado_por = item.creado_por;
      this.obj.ultimo_editar = item.ultimo_editar;
      this.obj.nombre = item.nombre;
      this.obj.create_at = item.create_at;
      this.obj.finish_at = item.finish_at;
      this.obj.prioridad = item.prioridad;
      this.obj.comentarios = item.comentarios;
      this.obj.estado = item.estado;
      this.dialog = true;
    },
    editAct(item) {
      this.obj.id = item.id;
      this.obj.creado_por = item.creado_por;
      this.obj.ultimo_editar = item.ultimo_editar;
      this.obj.nombre = item.nombre;
      this.obj.create_at = item.create_at;
      this.obj.finish_at = item.finish_at;
      this.obj.prioridad = item.prioridad;
      this.obj.comentarios = item.comentarios;
      this.obj.estado = item.estado;
    },
    abrirModal() {
      this.show = true;
      this.update = false;
    },
    editar(obj) {
      debugger;
      this.obj = obj;
      this.show = true;
      this.update = true;
    },
    guardar(obj) {
      debugger;
      if (this.update) {
        this.updateTarea({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      } else {
        this.saveTarea({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      }
      this.cerrar();
      this.getTareas();
    },

    eliminar() {},
    cerrar() {
      this.obj = {};
      this.dialog = false;
      this.show = false;
    },
  },
};
</script>

<style></style>
